export const ACCOUNT_PAGE_LOCKERS_MAP_ID = "ACCOUNT_PAGE_LOCKERS_MAP";
export const ACCOUNT_PAGE_MODAL_LOCKERS_MAP_ID =
  "ACCOUNT_PAGE_MODAL_LOCKERS_MAP";

export const ACCOUNT_PAGE_MODAL_ID = "ACCOUNT_PAGE_LOCKERS_MAP_MODAL";

export const PRODUCT_PAGE_LOCKERS_MAP_ID = "PRODUCT_PAGE_LOCKERS_MAP";
export const PRODUCT_PAGE_MODAL_LOCKERS_MAP_ID =
  "PRODUCT_PAGE_MODAL_LOCKERS_MAP";

export const RMA_PAGE_LOCKERS_MAP_ID = "RMA_PAGE_LOCKERS_MAP";
export const RMA_PAGE_MODAL_LOCKERS_MAP_ID = "RMA_PAGE_MODAL_LOCKERS_MAP";

export const LOCKER_INACTIVE_TAG = "Indisponibil";

export const LOCKER_INACTIVE_MESSAGE =
  "Acest punct de ridicare este momentan indisponibil. Te rugam sa alegi altul.";

export const FAVOURITE_LOCKER_INACTIVE_MESSAGE =
  "Punctul de ridicare salvat nu mai este disponibil. Te rugam sa alegi altul.";
